<section>
  <dls-tabs *ngIf="tabs.length > 0">
    <a *ngFor="let tab of tabs" (click)="onTabChange(tab.name)"
       [id]="tab.name+'-tab-header'"
       class="{{cssClassFormat(tab.name)}}"
       [ngClass]="{'pt-selected active-tab':tab.name === currentTabTitle}">
      <span class="tab-nameAuto_{{tab.name}}Auto_{{tab.id}}"id="{{tab.name}}"translate>{{tab.name}}</span>
    </a>
  </dls-tabs>
  <section *ngIf="summaryFormId" class="event-ribbon-container">

    <gen-dynamic-form [formName]="summaryFormId"
                      [listenToDataChange]="true"
                      [formData]="summaryFormData"
                      [editMode]="true"
                      [requiredMessage]=""
                      [formItemFullWidth]="true"
                      [formVertical]="false"
    >
    </gen-dynamic-form>

  </section>
  <section class="event-tab-content-wrapper" class="{{cssClassFormat(currentTabTitle)}}">
  <div *ngFor="let item of formConfig; index as i" class="event-tab-content info-dynamic-form">
    <gen-dynamic-form [formName]="item.formId"
                      [formData]="formData[i]"
                      [listenToDataChange]="false"
                      [editMode]="true"
                      [popupMode]="popUpMode"
                      [disabledForced]="disabled"
                      [requiredMessage]="''"
                      [formItemFullWidth]="true"
                      [formVertical]="item.formVertical"
                      (formInit)="onFormInit($event,i)"
                      (dataRecieved)="dataRecievedEvent($event, i)"
                      (formChange)="updateChanged($event,i, false)">
    </gen-dynamic-form>
  </div>
  </section>
</section>

